export const BoxModal = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
}

export const DeleteButton = {
  backgroundColor: "rgba(255, 0, 0, 0.1)",
  color: "rgba(255, 0, 0, 1)",
  width: "100%",
  marginBottom: "10px",
  "&:hover": {
    backgroundColor: "rgba(255, 0, 0, 0.1)",
  },
}

export const BankText = {
  margin: "10px 0 30px 0",
}